import React from 'react';

const DragAndDrop = () => (
    <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="2.46927" cy="2.46536" rx="2.13333" ry="2.13333" fill="#6B6C7B" />
        <circle cx="2.46927" cy="11.0005" r="2.13333" fill="#6B6C7B" />
        <ellipse cx="11.0005" cy="2.46536" rx="2.13333" ry="2.13333" fill="#6B6C7B" />
        <circle cx="11.0005" cy="11.0005" r="2.13333" fill="#6B6C7B" />
        <ellipse cx="19.5396" cy="2.46536" rx="2.13333" ry="2.13333" fill="#6B6C7B" />
        <ellipse cx="19.5396" cy="11.0005" rx="2.13333" ry="2.13333" fill="#6B6C7B" />
    </svg>
);

export default DragAndDrop;
